import { REGEXP_EMAIL, REGEXP_PHONE } from '@/constants/regex';

export const useMaskString = () => {
  const maskString = (str: string): string => {
    if (!str || str?.length < 2) return str;
    const isEmail = REGEXP_EMAIL.test(str);
    const isPhone = REGEXP_PHONE.test(str);
    if (isPhone) {
      let start = '';
      let end = '';
      if (str.length < 7) {
        start = str.slice(0, 1);
        end = str.slice(-1);
      } else if (str.length >= 11) {
        start = str.slice(0, 3);
        end = str.slice(-4);
      } else {
        start = str.slice(0, 2);
        end = str.slice(-2);
      }

      return `${start}****${end}`;
    } else {
      const [prefix, domain] = str.split('@');
      const keep = Math.max(0, Math.ceil(prefix.length / 2) - 2);
      const keepMax = keep > 3 ? 3 : keep; // Ensure we keep at least 4 characters if possible
      const masked = '*'.repeat(4);
      const start = prefix.slice(0, keepMax);
      const end = prefix.slice(-keepMax);
      if (isEmail) {
        return `${start}${masked}${end}@${domain}`;
      } else {
        return `${start}${masked}${end}`;
      }
    }
  };

  return {
    maskString,
  };
};
